import React from 'react';
import { router } from '@inertiajs/react';

// Prev/next pager for server-paginated Inertia lists.
//
// Always states the totals. The rest of this app caps long lists with a bare
// limit() and shows nothing, so a truncated list is indistinguishable from a
// complete one — the reader cannot tell whether they are seeing everything.
export default function Pagination({
  page, pages, total, from, to, path, label = 'items', params = {},
}) {
  if (!total || pages <= 1) return null;

  // `params` carries any active filters. Without merging them, paging a
  // filtered list silently drops the filter and page 2 shows a different set
  // of rows than page 1.
  const go = (target) => {
    router.get(path, { ...params, page: target }, { preserveState: true, preserveScroll: true });
  };

  const btn =
    'rounded-lg border border-gray-200 px-3 py-1.5 text-sm font-semibold text-gray-700 ' +
    'hover:bg-gray-50 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <nav className="flex items-center justify-between gap-3 flex-wrap" aria-label="Pagination">
      <p className="text-xs text-gray-500">
        Showing <span className="font-medium text-gray-700">{from}–{to}</span> of{' '}
        <span className="font-medium text-gray-700">{total}</span> {label}
      </p>

      <div className="flex items-center gap-2">
        <button type="button" className={btn} disabled={page <= 1} onClick={() => go(page - 1)}>
          Previous
        </button>
        <span className="text-xs text-gray-500">Page {page} of {pages}</span>
        <button type="button" className={btn} disabled={page >= pages} onClick={() => go(page + 1)}>
          Next
        </button>
      </div>
    </nav>
  );
}
